import { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "@/i18n/LangContext";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reviews() {
  const { t, lang } = useLang();
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/reviews`).then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-24 sm:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-overline text-[#0097b2] mb-4">
            {t.reviews.overline}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#121C26]">
            {t.reviews.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[#E0DACE] border border-[#E0DACE]">
          {reviews.map((r) => (
            <article
              key={r.id}
              data-testid={`review-${r.id}`}
              className="bg-[#FAF9F6] p-10"
            >
              <div className="flex gap-1 mb-5">
                {Array.from({ length: r.rating }).map((_, i) => (
                  <Star
                    key={i}
                    size={16}
                    strokeWidth={1.25}
                    className="fill-[#0097b2] text-[#0097b2]"
                  />
                ))}
              </div>
              <p className="font-serif text-2xl text-[#121C26] leading-snug mb-6">
                &ldquo;{lang === "it" ? r.quote_it : r.quote_en}&rdquo;
              </p>
              <div className="text-sm">
                <p className="text-[#121C26]">{r.author}</p>
                <p className="text-[#0097b2]">
                  {r.country} · {r.stay_date}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
